/**
 * Created with IntelliJ IDEA.
 * User: elanh
 * Date: 3/6/13
 * Time: 6:45 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    'use strict';

    var Marionette = require("marionette");
    var LEResourceResolver = require("leResourceResolver");
    var RouteNameBuilder = require("routers/routeNameBuilder");
    var Logger = require("logger");

    var LiveEngageRouteController = Marionette.Controller.extend({
        logger:Logger.getLogger("LEFramework"),

        //define route/handler map
        navigation:{
            routes:{
                "*notFound":"notFound", // This MUST be the first route definition in order to only match undefined urls
                "404":"notFound",
                "":"defaultRoute",
                "login(/:errorCode)":"login",
                "denied(/:errorCode)":"denied"
                //todo: add not found route that matches routes that are not defined
            },
            defaultRoute:""
        },

        initialize:function (options) {
            options = options || {};
            this.App = options.App;
        },

        //handler definitions
        defaultRoute:function (path) {
            this.logger.debug('--------------------------LiveEngageRouteController - showing the default');
        },

        login:function (errorCode) {
            this.doLogin("RealTime", errorCode);
        },

        denied:function (errorCode) {
            this.doDenied("RealTime", errorCode);
        },

        doLogin:function (loginType, errorCode) {
            this.doAppServerRedirect("Login", loginType, errorCode);
        },

        doDenied:function (deniedType, errorCode) {
            this.doAppServerRedirect("AccessDenied", deniedType, errorCode);
        },

        doAppServerRedirect:function (redirectType, internalType, errorCode) {
            var absolute = LEResourceResolver.getWindowLocation({ removeTrailing:true });
            var parts = LEResourceResolver.getUrlParts(absolute);
            var local = parts.pathname.replace(new RegExp("^/"), '');
            var hash = "#,~~ssokey~~";

            if (0 < this.App.loginInfo.outerRoute.length && _.isUndefined(this.navigation.routes[this.App.loginInfo.outerRoute])) {
                hash += ";" + this.App.loginInfo.outerRoute;
            }

            local = local.replace(this.App.loginInfo.accountId, "~~accountid~~");

            if ((local.length - 1) !== local.lastIndexOf("/") || 0 !== hash.indexOf("/")) {
                local += "/";
            }

            var params = { ServicePath:encodeURIComponent(local + hash) };

            if (!_.isNaN(errorCode) && 0 < errorCode) {
                params.errorCode = "&error=" + errorCode.toString();
            } else {
                params.errorCode = "";
            }

            var res = LEResourceResolver.apiResources.LogoutUrl || LEResourceResolver.apiResources.AppServer[redirectType][internalType];
            var url = LEResourceResolver.getUrl($.extend({}, res, params));

            this.App.moduleManager.stopAllModules(_.bind(function(){
                this.App.isSilentLeave = true;
                this.App.router.replace(url, { full:true });
            }, this));
        },

        notFound:function (path) {
            var router;

            this.logger.info("Path: '" + path + "' not found! I'll route to default.");
            if (path) {
                this.logger.info("First try to parse the path and check for valid prefix.");
                var prefix = RouteNameBuilder.getRoutePrefix(path);
                this.logger.info("Found prefix - '" + prefix + "'.");
                this.logger.info("Try to resolve the module name for the prefix found.");
                var moduleName = this.App.moduleManager.resolveModuleNameByPrefix(prefix);

                if (moduleName && "" !== moduleName) {
                    this.logger.info("Found module name - '" + moduleName + "'.");
                    this.logger.info("Try to get the router for the module found.");
                    router = this.App.navigator.getEffectiveModuleRouter(moduleName);
                }

                if (!router) {
                    this.logger.info("Need to get the active router.");
                    router = this.App.navigator.getActiveRouter();
                }

                if (router) {
                    // Navigate to the default route of the active router
                    this.logger.info("I'll navigate to the router default route.");
                    router.navigate("");
                }
            }
        }
    });

    return LiveEngageRouteController;
});
